































import { Icon } from '@alpha/ink'
import autosize from 'autosize'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as db from '@shared/types/database'

@Component({
  components: {
    Icon
  }
})
export default class TextComparison extends Vue {
  @Prop({ required: true }) readonly list!: Record<string, db.Prototype>
  @Prop({ default: false }) readonly editable!: boolean
  @Prop({ default: 2 }) readonly minLength!: number
  @Prop({ default: 10 }) readonly maxLength!: number

  @Watch('editable', { immediate: true })
  editableUpdated () {
    if (this.editable && Object.keys(this.list).length < 2) {
      // start with minLength options, at least
      for (let i = Object.keys(this.list).length; i < this.minLength; i++) {
        this.addOption()
      }
    }
    this.$nextTick(() => {
      this.$refs.input && (this.$refs.input as Element[]).forEach(input => {
        autosize(input)
      })
    })
  }

  mounted () {
    this.$refs.input && (this.$refs.input as Element[]).forEach(input => {
      autosize(input)
    })
  }

  beforeDestroy () {
    this.$refs.input && (this.$refs.input as Element[]).forEach(input => {
      autosize.destroy(input)
    })
  }

  onEnter (index: number) {
    if (index + 1 === Object.keys(this.list).length) {
      this.addOption()
    } else {
      (this.$refs.input as HTMLElement[])[index + 1].focus()
    }
  }

  addOption () {
    this.$emit('addOption')
    this.$nextTick(() => {
      const inputs = this.$refs.input as HTMLElement[]
      // if we just added a new one (and not the first minlength ones), focus on it immediately
      if (inputs.length > this.minLength) {
        const lastIndex = inputs.length - 1
        inputs[lastIndex].focus()
      }
    })
  }

  removeOption (index: number) {
    this.$emit('removeOption', index)
  }
}
